/* eslint-disable lit-a11y/click-events-have-key-events */
/* eslint-disable max-classes-per-file */
import { customElement, property } from 'lit/decorators.js';
import { i18nMixin, responsiveMixin } from '../../decorators';
import {
  BaseTable,
  PromiseData,
  SortAble,
  ColumnHider,
  ColumnFormatter,
  Export,
  Selection,
  LazyRendering,
} from '../ki-table';
import { Mix } from '../../common';
import nls from '../../locales/index';
import ListMode from './ListMode';

@customElement('ki-responsive-table')
export default class KiResponsiveTable extends Mix(
  BaseTable,
  [i18nMixin, { nls }],
  Selection,
  responsiveMixin,
  PromiseData,
  SortAble,
  ColumnFormatter,
  ColumnHider,
  LazyRendering,
  ListMode,
  Export,
) {
  static nls = nls;

  @property({ type: Boolean })
  selectionActive = false;

  multiselection = true;

  _timeout;

  popupContainer;

  popupOptions = {};

  popupTimeout: ReturnType<typeof setTimeout> | undefined;

  constructor() {
    super();
    this.noDataMessage = this.i18n.t('noDataMessage');
    this.normalizeSpecialCharacters = true;
  }

  // eslint-disable-next-line class-methods-use-this
  get localStorageId() {
    return `ww-station-table-columnHidder`;
  }

  showPopup(station, e) {
    this.popupElement = document.createElement(
      this.popupComponent || 'ww-map-popup-auto',
    );

    this.popupElement.layerAlias = this.layerAlias;
    this.popupElement.stations = [station];
    this.popupElement.style.position = 'fixed';
    this.popupElement.style.background = 'white';
    this.popupElement.style.zIndex = '111';
    this.popupElement.style.border = '1px solid #ddd';
    this.popupElement.style.display = 'block';

    Object.assign(this.popupElement, this.popupOptions);
    document.body.appendChild(this.popupElement);
    // const tablebody = this.renderRoot.querySelector('.body');
    // const {top} = tablebody.getBoundingClientRect();
    const top = 150;
    const obs = new ResizeObserver(() => {
      if (this.popupElement.clientHeight > 0) {
        const topoffset = top + this.popupElement.clientHeight;
        const maxLeft =
          window.document.body.clientWidth - this.popupElement.clientWidth;
        const posY =
          e.clientY > topoffset
            ? e.clientY - this.popupElement.clientHeight
            : e.clientY;
        const posX =
          e.clientX > maxLeft
            ? e.clientX - this.popupElement.clientWidth - 30
            : e.clientX + 30;

        this.popupElement.style.left = `${posX}px`;
        this.popupElement.style.top = `${posY}px`;
      }
    });

    obs.observe(this.popupElement);
  }

  hidePopup() {
    if (this.popupElement) {
      this.popupElement.remove();
    }
  }

  disconnectedCallback() {
    if (super.disconnectedCallback) super.disconnectedCallback();
    this.hidePopup();
  }

  showPopupForItem(item, e) {
    this.hidePopup();
    this.showPopup(item, e);
  }

  startPopupTimer(item, e) {
    if (!this.classList.contains('sm-screen') && this.tablePopup) {
      if (this.popupTimeout) {
        clearTimeout(this.popupTimeout);
      }
      this.popupTimeout = setTimeout(() => this.showPopupForItem(item, e), 200);
    }
  }

  endPopupTimer() {
    if (this.popupTimeout) {
      clearTimeout(this.popupTimeout);
      this.popupTimeout = undefined;
    }
    this.hidePopup();
  }

  mouseenter(e, item) {
    this.startPopupTimer(item, e);
  }

  mouseleave(e) {
    this.endPopupTimer(e);
  }
}
